import React from 'react'
import { NextPage } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import HeadContainer from '@src/components/HeadContainer'
import Consult from '@src/features/wev/partnership/components/consult/Consult'
import { useTranslation } from 'next-i18next'

export const getStaticProps = async ({ locale }: any) => ({
  props: {
    ...(await serverSideTranslations(locale, ['layout', 'auth', 'partnership'])),
  },
})
const WEVPartnershipConsultPage: NextPage = () => {
  const { t } = useTranslation('layout')
  return (
    <>
      <HeadContainer title={`${t('site_map.사업 제휴 신청')}`} />
      <Consult />
    </>
  )
}

export default WEVPartnershipConsultPage
